import React from 'react';
import ChevronSolid from '@learningblocks/exp-constants/lib/Icons/chevron-down-solid';

export function DownIcon(props) {
  return <ChevronSolid className={props.className} />;
}

export function UpIcon(props) {
  return (
    <ChevronSolid
      className={props.className}
      style={{
        transform: 'rotate(180deg)',
      }}
    />
  );
}

export function LeftIcon(props) {
  return (
    <ChevronSolid
      className={props.className}
      style={{
        transform: 'rotate(90deg)',
      }}
    />
  );
}

export function RightIcon(props) {
  return (
    <ChevronSolid
      className={props.className}
      style={{
        transform: 'rotate(-90deg)',
      }}
    />
  );
}
